<template>
    <div class="fill-height">
        <TabBasic :key="refreshCount+'circleTab'" ref="tabBasic" :circle-ids="selectedCircleIDs" :items="items"
                  show-breadcrumbs :filter-open="filterOpen" @refreshPage="refreshPage">
            <template v-slot:header>
                <v-spacer/>
                <slot name="header"/>
                <v-col v-show="$route.name === 'circleMap'" cols="3">
                    <SelectFilter v-model="selectedCircleIDs" :items="filterItems"
                                  :show-all="$t('circles.showAllCircles')"
                                  color="accentText"
                                  @openMenu="openMenu"/>
                </v-col>
            </template>
        </TabBasic>
    </div>
</template>

<script>
import TabBasic from "@/components/reusable/TabBasic/TabBasic";
import SelectFilter from "@/components/reusable/SelectFilter/SelectFilter";

export default {
  name: "Circles",
  components: {SelectFilter, TabBasic},
  created() {
    if (this.organizationId) {
      this.initCircles();
    }
  },
  computed: {
    organizationId() {
      return this.$store.getters.getOrganizationId;
    },
    filterItems() {
      return this.circles.map((circle) => ({value: circle.CircleID, text: circle.Name}));
    },
    routeName() {
      return this.$route.name;
    }
  },
  watch: {
    routeName() {
      this.changeRoute = true;
      setTimeout(() => {
        this.changeRoute = false;
      }, 500);
    },
    organizationId() {
      this.initCircles();
    }
  },
  data() {
    return {
      tab: null,
      changeRoute: false,
      items: [
        {
          title: this.$t('circles.map'),
          to: {
            name: 'circleMap'
          }
        },
        {
          title: this.$t('circles.myCircles'),
          to: {
            name: 'myCircles'
          }
        }
      ],
      circles: [],
      selectedCircleIDs: [],
      openAddEditDialog: false,
      refreshCount: 0,
      filterOpen: false,
    };
  },
  methods: {
    refreshPage() {
      this.selectedCircleIDs = this.filterItems.map(item => item.value);
      if (!this.changeRoute) {
        this.refreshCount++;
      }
    },
    refreshTable() {
      if (this.$refs.tabBasic.$refs.dynamicComponent[1]) {
        this.$refs.tabBasic.$refs.dynamicComponent[1].initItems();
      }
    },
    initCircles() {
      const url = this.$store.getters.circles(this.organizationId);
      this.axios.get(url).then(({data}) => {
        this.circles = data.Result;
      }).finally(() => {
        this.loading = false;
      });
    },
    openMenu(val) {
      this.filterOpen = val;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "circles";
</style>